<sh-dropdown
    [label]="label() | translate"
    [disabled]="disabled() || isDisabled()"
    [attr.mandatory]="mandatory() ? true : null"
    [error]="error()"
    display="label"
    editable
    (input)="handleSearchInput($event)"
>
    <!-- Selected option (shown when not searching) -->
    @if (selectedOption(); as selected) {
        @if (!searchTerm()) {
            <sh-menu-item
                [icon]="selected.type === 'team' ? 'user-group' : 'user'"
                [iconColor]="selected.type === 'user' ? 'rgb(var(--ui-3))' : ''"
                [label]="
                    selected.type === 'team' ? selected.label + ' ' + (teamIndicator() | translate) : selected.label
                "
                [value]="selected.id"
                [active]="true"
                (click)="handleClear()"
            ></sh-menu-item>
        }
    }

    <!-- Loading -->
    @if (isLoading()) {
        <sh-menu-item [label]="'common.general.loading' | translate" disabled="true"></sh-menu-item>
    }

    <!-- Results (initial or filtered) -->
    @if (!isLoading() && searchResults().length > 0) {
        @for (option of searchResults(); track option.id) {
            <sh-menu-item
                [attr.data-testid]="optionTestId()"
                [icon]="option.type === 'team' ? 'user-group' : 'user'"
                [iconColor]="option.type === 'user' ? 'rgb(var(--ui-3))' : ''"
                [label]="option.type === 'team' ? option.label + ' ' + (teamIndicator() | translate) : option.label"
                [value]="option.id"
                (click)="handleSelect(option)"
            ></sh-menu-item>
        }
    }

    <!-- No results (only when actively searching) -->
    @if (!isLoading() && searchTerm() && searchResults().length === 0) {
        <sh-menu-item [label]="'common.scd-picker.errors.no-results' | translate" disabled="true"></sh-menu-item>
    }
</sh-dropdown>
